<template>
  <div class="questionnaire h5content column" v-if="info.id">
    <img :src="bj2" class="bj2" />
    <div class="top_title">
      <div class="title1">{{ info.infoCollectionSubtitle }}</div>
      <div class="title2">
        {{ info.activityDescription }}
      </div>
    </div>
    <div class="main submit" v-if="isSubmit">
      <img :src="illustration3" class="illustration3" />
      <img :src="submitBj" class="submit_img" />
      <div class="fs17">提交信息成功</div>
    </div>
    <div class="main" v-else>
      <img :src="illustration3" class="illustration3" />
      <van-field
        v-if="questionnaire.name"
        v-model="submitForm.name"
        class="input fs15cl333"
        label="您的姓名"
        placeholder="请输入姓名"
        maxlength="20"
      />
      <van-field
        v-if="questionnaire.phone"
        v-model="submitForm.phone"
        class="input fs15cl333"
        label="手机号码"
        placeholder="请输入手机号码"
        type="number"
        maxlength="11"
      />
      <div class="mt24" v-if="questionnaire.kqwt">
        <div class="mb12 fs15cl333">您口腔存在的问题</div>
        <div class="oral_list">
          <div
            :class="'oral_item ' + (item.selected ? 'selected' : '')"
            v-for="(item, index) in oralList"
            :key="index"
            @click="selectOralItem(index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <template v-if="questionnaire.other">
        <div class="mt24 fs15cl333">您要了解的其他问题</div>
        <van-field
          class="input fs15cl333"
          v-model="submitForm.otherProblem"
          type="textarea"
          rows="1"
          autosize
          placeholder="请输入问题"
          maxlength="200"
        />
      </template>
      <van-button class="btn" @click="submit">{{
        info.buttonTitle
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  getQuestionnaireInfo,
  submitQuestionnaire,
} from "@/api/customer/questionnaire.js";
import illustration3 from "@/assets/img/customer/illustration3.png";
import { loadingStore } from "@/store/loading.js";
import bj2 from "@/assets/img/customer/bj2.png";
import { getLoginInfo } from "@/api/base.js";
import tool from "@/util/debounce.js";
import func from "@/util/func.js";
import submitBj from "@/assets/img/customer/submit_bj.png";

export default {
  name: "questionnaire",
  setup() {
    let loading = loadingStore();
    return {
      loading,
    };
  },
  data() {
    return {
      bj2,
      illustration3,
      externalUserId: "",
      submitForm: {
        id: "", //获客码主键id
        name: "",
        phone: "",
        otherProblem: "",
      },
      oralList: [
        { name: "智齿", selected: false },
        { name: "龋齿", selected: false },
        { name: "牙结石", selected: false },
        { name: "牙齿不齐", selected: false },
        { name: "牙龈出血", selected: false },
        { name: "牙齿敏感", selected: false },
        { name: "牙齿酸痛", selected: false },
      ],
      info: {},
      questionnaire: {}, //问卷配置
      isSubmit: false,
      submitBj,
    };
  },
  mounted() {
    const that = this;
    const currentURL = window.location.href;
    const urlParams = new URLSearchParams(currentURL.split("?")[1]);
    const code = urlParams.get("code");
    //已经拿到授权信息了
    if (func.notEmpty(code)) {
      that.getUserInfo(urlParams);
    } else {
      //没有拿到信息先通过企微授权
      const url = currentURL.split("?")[0];
      const id = urlParams.get("id");
      const agentId = urlParams.get("agentId");
      const corpId = urlParams.get("corpId");
      const state = agentId + corpId;
      const openUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpId}&redirect_uri=${url}?id=${id}&response_type=code&scope=snsapi_base&state=${state}&agentid=${agentId}#wechat_redirect`;
      window.location.replace(openUrl);
    }
  },
  methods: {
    //选择口腔问题
    selectOralItem: tool._debouncefont(function (index) {
      const that = this;
      that.oralList[index].selected = !that.oralList[index].selected;
    }, 100),
    //获取用户信息
    getUserInfo(urlParams) {
      const that = this;
      const code = urlParams.get("code");
      const state = urlParams.get("state");
      const id = urlParams.get("id");
      that.submitForm.id = id;
      getLoginInfo({ code, state }).then((res) => {
        const { externalUserId } = res.data.data;
        //不是企微好友
        if (func.isEmpty(externalUserId)) {
          that.$message.warning("未找到您的企微好友信息");
          return;
        }
        that.externalUserId = externalUserId;
        //通过id获取获客码信息
        getQuestionnaireInfo({ id }).then((res) => {
          const { data } = res.data;
          //问题配置
          const { questionnaireJson } = data;
          const questionnaire = {};
          JSON.parse(questionnaireJson).forEach((item) => {
            questionnaire[item] = true;
          });
          //问卷配置
          that.questionnaire = questionnaire;
          //页面标题
          document.title = data.infoCollectionMainTitle;
          that.info = data || {};
        });
      });
    },
    //提交问卷
    submit: tool._debouncefont(function () {
      const that = this;
      const { externalUserId, submitForm, oralList, questionnaire } = that;
      //必填校验
      if (func.isEmpty(submitForm.name) && questionnaire.name) {
        that.$message.warning("请填写您的姓名");
        return;
      }
      if (func.isEmpty(submitForm.phone) && questionnaire.phone) {
        that.$message.warning("请填写您的手机号码");
        return;
      }
      that.loading.showLoading();
      //封装数据
      const oralProblem = oralList
        .filter(({ selected }) => selected)
        .map(({ name }) => name)
        .join(",");
      const data = {
        ...submitForm,
        externalUserId,
        oralProblem,
      };
      submitQuestionnaire(data)
        .then(() => {
          that.isSubmit = true;
        })
        .finally(() => {
          that.loading.hideLoading();
        });
    }, 2000),
  },
};
</script>

<style lang="scss" scoped>
.questionnaire {
  text-align: left;
  height: 100%;
  width: 100%;
  padding: 0;
  position: fixed;
  left: 0;
  top: 0;
  overflow: hidden;
  background-color: #00b884;
  overflow-y: auto;
  .bj2 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    aspect-ratio: 1 / 1; /* 设置宽高比为 1:1 */
  }
  .top_title {
    position: relative;
    z-index: 1;
    color: #fff;
    padding-top: 0.375rem;
    padding-left: 0.5rem;
    word-break: break-all;
    min-height: 2.4rem;
    .title1 {
      width: 4.65rem;
      font-size: 0.625rem;
      font-weight: bold;
      margin-bottom: 0.167rem;
    }
    .title2 {
      width: 3.75rem;
    }
  }

  .main {
    position: relative;
    background-color: #fff;
    padding: 0.3rem;
    margin: 0.3rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-shrink: 0;
    border-radius: 0.27rem;
    &.submit {
      justify-content: center;
      align-items: center;
      padding-bottom: 0.7rem;
    }
    .fs15cl333 {
      font-size: 0.313rem;
      color: #333;
    }
    .illustration3 {
      position: absolute;
      top: -2.7rem;
      right: -0.25rem;
      width: 3.35rem;
      height: 2.7rem;
    }
    .input {
      width: 100%;
      padding-left: 0;
      padding-right: 0;
      border-bottom: 1px solid #f1f1f1;

      /* 穿透 scoped，去掉 van-cell 底部分割线 */
      :deep(.van-cell:after) {
        border: none;
      }
    }
    .oral_list {
      display: flex;
      flex-wrap: wrap;
      gap: 0.167rem;

      .oral_item {
        display: inline-block;
        padding: 0.042rem 0.25rem;
        border-radius: 1.042rem;
        border: 1px solid #ededed;
        white-space: nowrap;

        &.selected {
          background: #00b884;
          color: #fff;
          border-color: #00b884;
        }
      }
    }
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 0.98rem;
      border-radius: 2.083rem;
      background: #00b884;
      box-sizing: border-box;
      color: #fff;
      text-align: center;
      font-size: 0.35rem;
      font-weight: 700;
      border: none;
      margin-top: 0.75rem;
    }
    .submit_img {
      width: 2.813rem;
      height: 2.813rem;
    }
  }
}
</style>
